export default __webpack_public_path__ + "static/media/credit-button-image.55e1c2e8.png";